import { formatApiDateRangeDisplay } from '#/utils/date';

/**
 * UI range DatePicker ↔ listQuery.filters（API：`created_at_from`／`created_at_to`）。
 */
export function readCreatedAtRangeFilter(filters = {}) {
  const from = filters.createdAtFrom;
  const to = filters.createdAtTo;

  if (!from && !to) {
    return undefined;
  }

  return {
    from: from ?? '',
    to: to ?? from ?? '',
  };
}

export function applyCreatedAtRangeToFilters(filters = {}, range) {
  const next = { ...filters };

  if (!range?.from && !range?.to) {
    delete next.createdAtFrom;
    delete next.createdAtTo;
    return next;
  }

  const from = range.from;
  const to = range.to || range.from;

  next.createdAtFrom = from || undefined;
  next.createdAtTo = to || undefined;

  return next;
}

export function resolveCreatedAtFilterChipDisplay(_values, ctx = {}) {
  const display = formatApiDateRangeDisplay({
    from: ctx.filters?.createdAtFrom,
    to: ctx.filters?.createdAtTo,
  });

  return display ? [display] : [];
}

/**
 * UI range DatePicker ↔ listQuery.filters（API：`updated_at_from`／`updated_at_to`）。
 */
export function readUpdatedAtRangeFilter(filters = {}) {
  const from = filters.updatedAtFrom;
  const to = filters.updatedAtTo;

  if (!from && !to) {
    return undefined;
  }

  return {
    from: from ?? '',
    to: to ?? from ?? '',
  };
}

export function applyUpdatedAtRangeToFilters(filters = {}, range) {
  const next = { ...filters };

  if (!range?.from && !range?.to) {
    delete next.updatedAtFrom;
    delete next.updatedAtTo;
    return next;
  }

  const from = range.from;
  const to = range.to || range.from;

  next.updatedAtFrom = from || undefined;
  next.updatedAtTo = to || undefined;

  return next;
}

export function resolveUpdatedAtFilterChipDisplay(_values, ctx = {}) {
  const display = formatApiDateRangeDisplay({
    from: ctx.filters?.updatedAtFrom,
    to: ctx.filters?.updatedAtTo,
  });

  return display ? [display] : [];
}
